import React from "react"
import { connect } from "react-redux"
import GenericDropdown from "../../../common/components/genericDropdown"
import AutomationCreationConsts from "../../automationCreationConsts"
import Consts from "../../../app/consts"

class StatusActionDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      menuAnchorEl: null,
      menuItems: AutomationCreationConsts.ACTION_STATUSES,
      selectedIndexesArr: [],
    }
  }

  handleMenuOpen = (event) => {
    this.setState({
      menuOpen: true,
      menuAnchorEl: event.currentTarget,
    })
  }

  handleMenuClose = () => {
    this.setState({
      menuOpen: false,
    })
  }

  handleMenuClick = (index) => {
    this.setState({
      selectedIndexesArr: index,
    })

    let selectedStatus = this.state.menuItems[index]
    this.props.handleSelect("actionValue", selectedStatus.status)

    this.handleMenuClose()
  }

  componentDidMount() {
    if (
      this.props.automationDetailsState.selectedActionType.actionType === Consts.ACTION_TYPE_STATUS &&
      this.props.automationDetailsState.actionValue
    ) {
      const selectedIndex = this.state.menuItems.findIndex(
        (item) => item.status === this.props.automationDetailsState.actionValue
      )
      if (selectedIndex !== -1) {
        this.handleMenuClick([selectedIndex])
      }
    }
  }

  render() {
    let buttonClassName = "creation-generic-dropdown-button "
    let header = "Choose status"
    if (this.state.selectedIndexesArr.length > 0) {
      header = this.state.menuItems[this.state.selectedIndexesArr[0]].name
      buttonClassName += "darker-text "
    }

    return (
      <div className={"text-field " + (this.props.statusActionValidationErrors ? "error " : "")}>
        <div className="creation-generic-dropdown-label">Status</div>
        <GenericDropdown
          header={header}
          selectOptionCallback={(index) => {
            this.handleMenuClick(index)
          }}
          options={this.state.menuItems}
          open={this.state.menuOpen}
          anchorEl={this.state.menuAnchorEl}
          selectedIndexes={this.state.selectedIndexesArr}
          openDropdownCallback={(event) => {
            this.handleMenuOpen(event)
          }}
          allowAutoSuggest={false}
          closeDropdownCallback={this.handleMenuClose}
          allowNoSelection={false}
          buttonClassName={buttonClassName}
          menuClassName={"value-type-dropdown-menu"}
        />
        {this.props.statusActionValidationErrors}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}

export default connect(mapStateToProps)(StatusActionDropdown)
